import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { count } from '../../config/helpers';
import { Fragment, useState } from 'react';
import dynamic from 'next/dynamic';

const BoxContainer = dynamic(() => import("../Reusables/BoxContainer"));
const ParseHtml = dynamic(() => import("../../Custom/ParseHtml"));

const FAQ = ({template_page_settings, faqs}) => {
    const [expanded, setExpanded] = useState(Object.keys(faqs)[0]);

    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
    
    return (
        <BoxContainer>
            <Typography component="h1" variant="h3" className="fe-light text-center">Frequently Asked Questions</Typography>
            {count(Object.keys(faqs)) > 0 && (
                Object.keys(faqs).map((el, idx) => (
                    <Accordion key={idx} expanded={expanded === el} onChange={handleChange(el)}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`faq-${idx}`}
                            id={`faq-${idx}-header`}
                        >
                            <Typography className="f-size_3 fw-bold" color="primary" sx={{ width: '33%', flexShrink: 0 }}>
                                {el}
                            </Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            {
                                faqs[el].map((faq, index) => (
                                    <div className="mb-3" key={faq.universal_template_faq_list_id}>
                                            <Typography className="fw-bold mb-1" variant="h6" component="h3">{faq.question}</Typography>
                                            <ParseHtml html={faq.answer}/>
                                    </div>
                                ))
                            }
                        </AccordionDetails>
                    </Accordion>
                ))
            )}
        </BoxContainer>
    )
}

export default FAQ